import { render } from "./IndexRayon.vue?vue&type=template&id=10745cfd"
import script from "./IndexRayon.vue?vue&type=script&lang=js"
export * from "./IndexRayon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__